import React, { Component } from "react";
import { MessageBox } from "react-chat-elements";

class LocationMessageBox extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { msg, dateFormatter } = this.props;

    return (
      <div>
        <MessageBox
          type={"location"}
          src={`https://maps.googleapis.com/maps/api/staticmap?center=${msg.content.latitude},${msg.content.longitude}&zoom=15&size=600x300&maptype=roadmap&markers=color:red%7C${msg.content.latitude},${msg.content.longitude}&key=AIzaSyBqHety4jjWm2r747ZT8L-pUDDQqCLY05o&v=3.exp`}
          href={`https://www.google.com/maps?q=${msg.content.latitude},${msg.content.longitude}`}
          position={msg.owner === "client" ? "left" : "right"}
          title={msg.owner === "client" ? undefined : msg.owner}
          dateString={dateFormatter(msg.timestamp)}
          className={`message-container ${msg.owner === "nadubot" ? "naduBotText" : msg.owner === "nadunet" ? "nadunetText" : "clientText"}`}
        />
      </div>
    );
  }
}

export default LocationMessageBox;



// WEBPACK FOOTER //
// ./src/views/NaduChat/components/LocationMessageBox.jsx